<template>
  <div
    class="question-details-wrapper"
    :class="question.precondition ? 'follow-up' : ''"
  >
    <div
      class="question-card card d-flex flex-column justify-content-between h-100"
    >
      <div
        v-if="shouldDisplayLoadButton"
        class="d-flex justify-content-center my-5"
      >
        <div class="d-flex justify-content-center">
          <div class="text-center">
            <button
              class="btn btn-primary btn-round"
              @click="() => loadQuestionResponses(question)"
            >
              {{ $t('widgetGroupPriorities.freeTextResponses') }}
            </button>
            <span class="text-info d-flex align-items-center mt-5">
              <i class="bi bi-info-circle-fill text-info fs-5 me-2"></i>
              {{ $t('categoryDetails.sensitiveQuestion') }}
            </span>
          </div>
        </div>
      </div>

      <div v-else-if="shouldDisplayNoAnswers" class="m-5">
        <div class="alert alert-info mb-0">
          <span class="fs-5">{{ $t('categoryDetails.noResponses') }}</span>
        </div>
      </div>

      <PulsListGroup
        v-else
        wrapper-class="free-text-widget px-8 pt-3"
        title-class="freetextresponse"
        text-class="free-text-date text-muted"
        :items="answersTransformed"
      />

      <div class="card-footer d-flex align-items-center">
        <p class="card-question mb-0">{{ $tr(question.messages, 'title') }}</p>
      </div>
    </div>
    <div
      v-if="question.numberOfSensitiveQuestions > 0"
      class="card-body text-info sensitive-text d-flex align-items-center justify-content-start"
    >
      <i class="bi bi-info-circle-fill text-info fs-5 me-2"></i>
      {{ $t('categoryDetails.sensitiveQuestion') }}
    </div>
    <!-- TODO: find a way to check if we should ever see freetext ownresponses -->
    <!-- <div
      v-if="
        question.ownResponse.isSet &&
        !shouldHideOwnAnswers &&
        question.ownResponse.value !== 'null'
      "
      class="card-footer px-5"
    >
      <div class="stats default-cursor">
        <transition name="fade" mode="out-in">
          <div class="own-response-container d-flex align-items-center">
            <i class="bi bi-person-fill fs-5 me-1"></i>
            <span class="own-response">
              {{ $t('categoryDetails.yourResponse') }}
              {{ question.ownResponse.value }}
            </span>
          </div>
        </transition>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'QuestionDetailsFreetext',
  components: {},
  props: {
    question: {
      type: Object,
      default: () => {}
    },
    loadQuestionResponses: {
      type: Function,
      default: () => null
    },
    freeTextVisualizerView: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    answers() {
      return this.question.answers || []
    },
    answersTransformed() {
      return this.answers.map((a, i) => {
        const text = a.date.split('T')[0]
        return {
          key: i,
          title: a.value,
          text
        }
      })
    },
    shouldDisplayLoadButton() {
      return (
        // this.answers.length === 0 &&
        this.freeTextVisualizerView ||
        (this.question.amount > 0 && !this.question.hasOwnProperty('answers'))
        // !this.doesNotHaveEnoughAnswers
      )
    },
    shouldDisplayNoAnswers() {
      return (
        this.question.hasOwnProperty('answers') &&
        this.question.answers.length === 0
      )
    }
  }
}
</script>

<style lang="scss">
.free-text-widget {
  .text-muted {
    color: var(--kt-text-muted) !important;
  }
  tr > td {
    display: block;
  }
  .flex-grow-1 > div {
    margin-top: 4px;
    text-align: right;
  }
}
</style>

<style lang="scss" scoped>
.question-details-wrapper {
  height: 100%;
  &.follow-up {
    margin-top: 10px;
    height: calc(100% - 10px);
    .question-card {
      background-color: rgba(var(--kt-gray-200-rgb), 0.5);
    }
  }
}

.question-card {
  background-color: rgba(var(--kt-gray-100-rgb), 0.4);
}
.stats {
  flex: 2;
}
.default-cursor {
  cursor: default;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.comments-body {
  overflow: scroll;
  max-height: 340px;
}
@media (max-width: 768px) {
  .comments-body {
    overflow: scroll;
    max-height: 400px;
  }
}
.own-response {
  text-overflow: ellipsis;
}
.own-response-container {
  overflow: hidden;
  white-space: nowrap;
  max-width: 240px;
}
</style>

<style lang="scss">
.question-details-wrapper {
  height: 100%;
}
.popover-header {
  font-size: 14px !important;
}
.free-text-widget {
  max-height: 400px;
  margin-top: 10px;
  span {
    font-size: 1.05rem !important;
    font-weight: 400 !important;
    color: var(--kt-gray-900) !important;
  }

  tr {
    display: block;
    padding: 10px 15px !important;
    // background: #fbfcdc !important;
    background: var(--kt-warning-light) !important;
    border-radius: 15px !important;
    margin-bottom: 10px !important;
    border: none !important;
    // background-color: rgb(253, 251, 240);
  }
  td {
    padding: 0 !important;
    border: none !important;
  }
}
</style>
